module.exports = __webpack_public_path__ + "static/media/banner_m_04.f484626c.jpg";